import { ArrowLeft, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF7]" data-testid="datenschutz-page">
      {/* Header */}
      <header className="bg-white border-b border-border">
        <div className="section-container py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
            data-testid="back-to-home"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="section-container py-16">
        <div className="max-w-3xl">
          <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-foreground mb-6">
            Datenschutzerklärung
          </h1>
          <p className="text-muted-foreground mb-12">Stand: Januar 2025</p>

          {/* Verantwortlicher */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              1. Verantwortlicher
            </h2>
            <div className="bg-white p-6 rounded-2xl border border-border/40">
              <p className="text-lg font-medium text-foreground mb-1">Christopher Mein</p>
              <p className="text-muted-foreground mb-4">CM Consulting</p>
              <div className="space-y-2 text-muted-foreground">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                  <span>Helmstedter Straße 24, 38102 Braunschweig</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                  <span>+49 176 81239688</span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                  <span>kontakt@christopher-mein.de</span>
                </div>
              </div>
            </div>
          </section>

          {/* Allgemeines */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              2. Allgemeines zur Datenverarbeitung
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Der Schutz deiner persönlichen Daten ist mir wichtig. Diese Datenschutzerklärung informiert dich 
                darüber, welche Daten ich erhebe, wie ich sie verwende und welche Rechte du hast.
              </p>
              <p>
                Ich verarbeite personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen 
                Website sowie meiner Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt auf 
                Grundlage der EU-Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG).
              </p>
            </div>
          </section>

          {/* Hosting */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              3. Hosting und Server-Log-Dateien
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Beim Besuch dieser Website werden automatisch Informationen in sogenannten Server-Log-Dateien 
                gespeichert, die dein Browser automatisch übermittelt:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und Betriebssystem</li>
              </ul>
              <p>
                Diese Daten werden zur Gewährleistung eines reibungslosen Verbindungsaufbaus der Website, 
                zur Gewährleistung einer komfortablen Nutzung sowie zur Auswertung der Systemsicherheit 
                und -stabilität verarbeitet. Die Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
              </p>
            </div>
          </section>

          {/* Kontaktformular */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              4. Kontaktformular
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Wenn du das Kontaktformular auf dieser Website nutzt, werden folgende Daten erhoben:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Vorname</li>
                <li>E-Mail-Adresse</li>
                <li>Nachrichteninhalt</li>
              </ul>
              <p>
                Diese Daten werden ausschließlich zur Bearbeitung deiner Anfrage verwendet und nicht an 
                Dritte weitergegeben. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
                (Vertragsanbahnung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung 
                von Kundenanfragen).
              </p>
              <p>
                Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht 
                mehr erforderlich sind, spätestens jedoch nach Ablauf gesetzlicher Aufbewahrungsfristen.
              </p>
            </div>
          </section>

          {/* Calendly */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              5. Terminbuchung (Calendly)
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Für die Terminbuchung nutze ich den Dienst Calendly der Calendly LLC, 271 17th Street NW, 
                10th Floor, Atlanta, GA 30363, USA.
              </p>
              <p>
                Bei der Buchung eines Termins werden die von dir eingegebenen Daten (Name, E-Mail, ggf. 
                weitere Angaben) an Calendly übermittelt und dort verarbeitet. Calendly verwendet diese 
                Daten zur Terminkoordination und sendet Bestätigungs- und Erinnerungs-E-Mails.
              </p>
              <p>
                Die Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung). Weitere Informationen 
                findest du in der Datenschutzerklärung von Calendly: 
                <a 
                  href="https://calendly.com/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline ml-1"
                >
                  calendly.com/privacy
                </a>
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              6. Cookies
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Diese Website verwendet Cookies. Cookies sind kleine Textdateien, die auf deinem Endgerät 
                gespeichert werden und die bestimmte Einstellungen und Daten zum Austausch mit meiner 
                Website speichern.
              </p>
              
              <h3 className="font-medium text-foreground mt-6 mb-3">Technisch notwendige Cookies</h3>
              <p>
                Einige Cookies sind technisch notwendig, damit diese Website ordnungsgemäß funktioniert. 
                Diese Cookies werden nach Ende der Browser-Sitzung automatisch gelöscht (Session-Cookies). 
                Die Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
              </p>
              
              <h3 className="font-medium text-foreground mt-6 mb-3">Cookie-Einstellungen</h3>
              <p>
                Du kannst deine Cookie-Einstellungen jederzeit über den Cookie-Banner auf dieser Website 
                anpassen. Zudem kannst du in deinen Browsereinstellungen festlegen, ob Cookies gesetzt 
                werden dürfen oder nicht.
              </p>
            </div>
          </section>

          {/* Deine Rechte */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              7. Deine Rechte
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>Du hast gemäß DSGVO folgende Rechte:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong className="text-foreground">Auskunftsrecht (Art. 15 DSGVO):</strong> Du kannst Auskunft 
                  über deine von mir verarbeiteten personenbezogenen Daten verlangen.
                </li>
                <li>
                  <strong className="text-foreground">Berichtigungsrecht (Art. 16 DSGVO):</strong> Du kannst die 
                  Berichtigung unrichtiger oder die Vervollständigung deiner gespeicherten Daten verlangen.
                </li>
                <li>
                  <strong className="text-foreground">Löschungsrecht (Art. 17 DSGVO):</strong> Du kannst die 
                  Löschung deiner gespeicherten Daten verlangen, soweit nicht gesetzliche Aufbewahrungspflichten 
                  entgegenstehen.
                </li>
                <li>
                  <strong className="text-foreground">Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Du 
                  kannst die Einschränkung der Verarbeitung deiner Daten verlangen.
                </li>
                <li>
                  <strong className="text-foreground">Datenübertragbarkeit (Art. 20 DSGVO):</strong> Du kannst 
                  deine Daten in einem strukturierten, gängigen und maschinenlesbaren Format erhalten.
                </li>
                <li>
                  <strong className="text-foreground">Widerspruchsrecht (Art. 21 DSGVO):</strong> Du kannst 
                  jederzeit gegen die Verarbeitung deiner Daten Widerspruch einlegen.
                </li>
              </ul>
              <p className="mt-6">
                Zur Ausübung deiner Rechte wende dich bitte an:{" "}
                <a href="mailto:kontakt@christopher-mein.de" className="text-primary hover:underline">
                  kontakt@christopher-mein.de
                </a>
              </p>
            </div>
          </section>

          {/* Beschwerderecht */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              8. Beschwerderecht bei einer Aufsichtsbehörde
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung deiner 
                personenbezogenen Daten zu beschweren.
              </p>
              <div className="bg-sage-50 p-6 rounded-2xl mt-4">
                <p className="font-medium text-foreground mb-2">Zuständige Aufsichtsbehörde:</p>
                <p>
                  Die Landesbeauftragte für den Datenschutz Niedersachsen<br />
                  Prinzenstraße 5<br />
                  30159 Hannover<br />
                  <a 
                    href="https://www.lfd.niedersachsen.de" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    www.lfd.niedersachsen.de
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Datensicherheit */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              9. Datensicherheit
            </h2>
            <div className="text-muted-foreground leading-relaxed space-y-4">
              <p>
                Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine 
                verschlüsselte Verbindung erkennst du daran, dass die Adresszeile des Browsers von 
                „http://" auf „https://" wechselt und an dem Schloss-Symbol in deiner Browserzeile.
              </p>
              <p>
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die du an mich 
                übermittelst, nicht von Dritten mitgelesen werden.
              </p>
            </div>
          </section>

          {/* Änderungen */}
          <section className="mb-12">
            <h2 className="font-heading text-2xl font-medium text-foreground mb-6">
              10. Änderungen dieser Datenschutzerklärung
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Ich behalte mir vor, diese Datenschutzerklärung anzupassen, um sie an geänderte rechtliche 
              Rahmenbedingungen oder Änderungen meiner Dienstleistungen anzupassen. Die jeweils aktuelle 
              Fassung findest du auf dieser Website.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-sage-800 text-white py-8">
        <div className="section-container text-center">
          <p className="text-sage-400 text-sm">
            © {new Date().getFullYear()} CM Consulting – Christopher Mein. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Datenschutz;
